import Cookies from "universal-cookie";
export const cookies = new Cookies();

export const COOKIE_OPTS = {
  path: "/",
  sameSite: "strict",
  secure: window.location.protocol === "https:",
};
